const NAME = "THIRD_PARTY_CLASSIFICATION";

export default NAME;
